import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import Event from '../components/Event.vue'
import Login from '../components/Login.vue'
import SignUp from '../components/SignUp'
import { fb } from '../services/firebase'

Vue.use(Router);

const EditEvent = () => import('@/pages/EditEvent');

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            redirect: '/login'
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/events/details/:id',
            name: 'Event',
            component: Event,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/manage-events/event/edit/:id',
            name: 'EditEvent',
            component: EditEvent,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/sign-up',
            name: 'SignUp',
            component: SignUp
        }
    ]
});

router.beforeEach((to, from, next) => {
    let currentUser = fb.auth().currentUser;
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) {
        next('login');
    } else if (!requiresAuth && currentUser) {
        next('/');
    } else {
        next();
    }
});

export default router;